import React from 'react';
import {
  List,
  Datagrid,
  TextField
} from "admin-on-rest";
import IconNext from 'material-ui/svg-icons/navigation/chevron-right';
import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";
import { LinkButton } from '../components/button';

export const TicketList = props => (
  <List
    {...props}
    title={<IconTitle icon="ticket" title={"resources.tickets.title"} />}
    perPage={10}
    pagination={<Pagination />}
  >
    <Datagrid bodyOptions={{ showRowHover: true }} styles={datagridStyles}>
      <TextField label="resources.tickets.field.name" source="name" />
        <LinkButton urlPath="/view"/>
        <LinkButton urlPath="/scan" icon={<IconNext/>}/>
    </Datagrid>
  </List>
);

const datagridStyles = {
  table: { },
  tbody: { },
  tr: { },
  header: {
      th: { width: 30},
      'th:first-child': {width: '100%' }, 
  },
  cell: {
      td: { textAlign:'center'},
      'td:first-child': { textAlign: 'left'},
  },
};


// WEBPACK FOOTER //
// ./src/tickets/index.js